
import 'apps/hiring/styles/modal.scss';
import React, { Fragment } from 'react';
import Query from 'apps/hiring/util/query';
import { resolve } from 'library/helpers/path-resolver';
import { ShimmyValue } from 'library/components/shimmy';
import { ModalComponent as Modal } from 'library/helpers/modal';
import SavingButton from 'library/components/saving-button';
import withUser from 'util/hoc/with-user';

class CreateOrg extends React.Component {
  state = {
    createOrg: null,
    org_name: '',
    saving: false
  }

  startTrial = () => {
    this.setState({
      createOrg: true
    });
  }

  handleChange = ({ target }) => {
    const {
      name,
      value
    } = target;

    this.setState({
      [name]: value
    });
  }

  handleCreateOrg = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    this.setState({
      saving: true
    });

    const results = await new Query(`
      mutation {
        create_organization(name: "${this.state.org_name.replace(/["]+/g, '')}") {
          success
          errors
          organization {
            id
            name
          }
        }
      }
    `);

    if (resolve(results, 'data/create_organization/success', false)) {
      const org_id = resolve(results, 'data/create_organization/organization/id', null);

      this.setState({
        createOrg: false
      });

      setTimeout(()=>{
        this.props.setOrganization(org_id, true);
      }, 250);
    }

    this.setState({
      saving: false
    });
  }

  render() {
    return (
      <Fragment>
        <ShimmyValue namespace="hiring-navigation-logo-text">
          <h1 className="pairin-hiring-masthead-label">Welcome to Hiring</h1>
        </ShimmyValue>
        <div className="hiring-app-get-started">
          <button onClick={this.startTrial}>FREE 14 DAY TRIAL</button>
          <Modal onClose={()=>this.setState({createOrg: false})} active={this.state.createOrg}>
            <div className="hiring-modal">
              <div className="hiring-modal-header">
                <div className="hiring-modal-header-inner">
                  <h1>Name your Organization</h1>
                  <a onClick={()=>this.setState({createOrg: false})} href="javascript:void(0)">×</a>
                </div>
                <svg className="hiring-modal-header-svg" width="100%" height="20px" viewBox="0 0 100 50" preserveAspectRatio="none">
                  <path className="hiring-modal-header-svg-first" fill="currentColor" strokeWidth="0" d={`M0,0 100,0 100,50 0,0`}></path>
                  <path className="hiring-modal-header-svg-second" fill="currentColor" strokeWidth="0" d={`M0,0 100,0 0,50 0,0`}></path>
                </svg>
              </div>
              <div className="hiring-modal-body">
                <form className="form-inline" onSubmit={this.handleCreateOrg}>
                  <input name="org_name" value={this.state.org_name} onChange={this.handleChange} type="text" placeholder="Organization Name" />
                  <SavingButton saving={this.state.saving} type="submit">START</SavingButton>
                </form>
              </div>
            </div>
          </Modal>
        </div>
      </Fragment>
    );
  }
}

export default withUser(CreateOrg);
